import { AgencyShortData, AgencyShortDataModel, IdModel } from 'src/types';

import { SimpleSelectData } from 'src/types';

export const agenciesAdapterToShortData = (agencies: AgencyShortDataModel[]): AgencyShortData[] => {
  return agencies.map((agency) => ({
    ...agency,
    city: agency.city.name,
  }));
};

export const exportAgenciesSimpleToSimpleSelectData = (
  agencies: {
    name: string;
    id: IdModel;
    city: string;
  }[],
): SimpleSelectData => {
  return agencies.map((agency) => ({
    label: `${agency.name}`,
    value: agency.id,
  }));
};
